import {
  ENDPOINT_ADMIN_STATUS_GET,
  ENDPOINT_ADMIN_STATUS_LIST,
  ENDPOINT_ADMIN_STATUS_RESTART
} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const find = require('mn-utils/find');
const {
  apiRequest,
} = require('../ws');


const status$ = new Emitter([
  {
    id: 'processing',
    name: 'Processing',
    checked: 1,
  },
  {
    id: 'arbitrage',
    name: 'Arbitrage',
    staticFiles: 1,
    checked: 1,
  },
  {
    id: 'console',
    name: 'Console',
    staticFiles: 1,
    checked: 1,
  },
  {
    id: 'shop',
    name: 'Shop',
    staticFiles: 1,
    checked: 1,
  },
  {
    id: 'statisctic_service',
    name: 'Statisctic service',
    checked: 1,
  },
  {
    id: 'etherscan_service',
    name: 'Etherscan service',
    checked: 1,
  },
  {
    id: 'wallet_back_end',
    name: 'Wallet back-end',
    checked: 1,
  },
]);

export function apiAdminStatusList() {
  if (process.env.MOCK || 1) {
    return CancelablePromise.delay(500, {
      list: status$.getValue(),
    });
  }
  return apiRequest(ENDPOINT_ADMIN_STATUS_LIST);
}
export function apiAdminStatusGet(params) {
  if (process.env.MOCK || 1) {
    return apiStatusList().then((v) => find(v.list, ['id', params.id]));
  }
  return apiRequest(ENDPOINT_ADMIN_STATUS_GET, params);
}
export function apiAdminStatusRestart(params) {
  if (process.env.MOCK || 1) {
    return CancelablePromise.delay(2000, {});
  }
  return apiRequest(ENDPOINT_ADMIN_STATUS_RESTART, params);
}
